import { createReducer, on } from '@ngrx/store';
import * as proofOfAddressDocumentTypesActions from '../actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const proofOfAddressDocumentTypesFeatureKey = 'proofOfAddressDocumentTypes';

export interface ProofOfAddressDocumentTypesState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: ProofOfAddressDocumentTypesState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(proofOfAddressDocumentTypesActions.fromProofOfAddressDocumentTypesAction.loadProofOfAddressDocumentTypes, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(proofOfAddressDocumentTypesActions.fromProofOfAddressDocumentTypesAction.loadProofOfAddressDocumentTypesSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    data: response,
    error: null
  })),
  on(proofOfAddressDocumentTypesActions.fromProofOfAddressDocumentTypesAction.loadProofOfAddressDocumentTypesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export const getProofOfAddressDocumentTypes = (state: ProofOfAddressDocumentTypesState) => state.data;
export const getProofOfAddressDocumentTypesLoading = (state: ProofOfAddressDocumentTypesState) => state.loading;
export const getProofOfAddressDocumentTypesError = (state: ProofOfAddressDocumentTypesState) => state.error;
